import * as IoC from 'inversify';
import { registerCommand, registerQuery } from '@/app/tracking/api';
import { sectionStateCommonTrackingModule } from '../common/di'
import * as Api from '../api'
import * as Common from '../common'
import { EmptyCommandHandler } from '@/app/tracking/common';
import { Scorm2004UpdateSessionTimeCommandHandler } from './scorm2004-update-session-time-command-handler'

const sectionStateScorm2004TrackingModule = new IoC.ContainerModule((bind) => {
  registerCommand(Api.UpdateSectionStateCommandName, Common.UpdateSectionStateCommandHandler, bind);
  registerCommand(Api.CompleteSectionCommandName, EmptyCommandHandler, bind);
  registerCommand(Api.AddSectionDurationCommandName, Common.AddSectionDurationCommandHandler, bind);
  registerCommand(Api.UpdateSessionTimeCommandName, Scorm2004UpdateSessionTimeCommandHandler, bind);
  registerQuery(Api.QuerySectionStatesTrackingQueryName, Common.QuerySectionStatesQueryHandler, bind);
})

export const sectionStateScorm2004TrackingModules = [
  sectionStateCommonTrackingModule,
  sectionStateScorm2004TrackingModule
]
